/**
 * API: aceptación de los documentos legales (sep 2026).
 *
 * `acceptLegalDocuments` envía las versiones del texto que la persona tuvo en
 * pantalla; si el backend ya rige otra, responde 409 y no registra nada.
 */

import type { LegalDocId } from "@/legal/documentos";

import { request } from "./_client";

export interface LegalAcceptanceDTO {
  document: LegalDocId;
  version: string;
  accepted_at: string;
}

export interface LegalStatusDTO {
  current_versions: Record<LegalDocId, string>;
  pending: LegalDocId[];
  acceptances: LegalAcceptanceDTO[];
}

export function fetchLegalAcceptances(): Promise<LegalStatusDTO> {
  return request<LegalStatusDTO>("/legal/acceptances");
}

export function acceptLegalDocuments(
  versions: Record<LegalDocId, string>,
): Promise<LegalStatusDTO> {
  return request<LegalStatusDTO>("/legal/accept", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(versions),
  });
}
